import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/lib/util/colors'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'

const vuetify = createVuetify({
  ssr: true,
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1287CD',
        icon: '#203A4D',
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base // #3F51B5
      },
      dark: {
        primary: '#1287CD',
        icon: '#1287CD'
      }
    }
  }
})

export default vuetify
